import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const users = {
  state: () => ({
    items: [],
    timeout: null,
    filter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
    groups: [],
    roles: [],
  }),
  mutations: {
    setUsers(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedUsers(state, payload) {
      state.selectedItems = payload;
    },
    setUsersPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getUsers");
    },
    setUsersTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getUsers");
    },
  },
  actions: {
    async getUsers(store) {
      store.state.loading = true;
      clearTimeout(store.state.timeout);
      store.state.timeout = null;
      store.state.timeout = setTimeout(async () => {
        await axios
          .post("User/load", {
            ...store.state.filter,
            skip: (store.state.filter.page - 1) * store.state.filter.take,
          })
          .then((res) => {
            store.state.loading = false;

            var users = [];

            res.data.data.event.users.map((i) => {
              users.push({
                ...i,
                userDetail: res.data.data.items.find((k) => k.id == i.userID),
              });
            });

            store.state.items = users;
          });
      }, 25);
    },
    async getUserGroups(store) {
      await axios.post("role/load", {}).then((res) => {
        store.state.groups = res.data.data.items;
      });
    },
    async loadAllRoles(store) {
      await axios.post("role/loadAllRoles", {}).then((res) => {
        var data = [];

        res.data.data.items.map((i, index) => {
          i.selectedRoles = [];
          data[index] = i;
        });

        store.state.roles = data;
      });
    },
    async toggleUsers(store, payload) {
      var res = await axios.post("Users/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteUser(store, payload) {
      await axios
        .post("User/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setUsersPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
    async deleteRole(store, payload) {
      await axios
        .post("role/delete", {
          id: store.state.groups[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.dispatch("getUserGroups");
            payload.context.$message.success(res.data.alert.message);
          }
        });
    },
  },
  getters: {},
};
export default users;



// WEBPACK FOOTER //
// ./src/store/users.js